import { createSelector } from '@reduxjs/toolkit';

import { selectSessionUserId } from '../session';
import { RootState } from '../store';
import { selectIsFreeTrialUser, selectPlan } from '../user-api';

export const selectActiveModal = (state: RootState) => state.ui.modals[0];

export const selectActiveModalParams = (state: RootState) =>
  selectActiveModal(state)?.params;

export const selectToasts = (state: RootState) => state.ui.toasts;

export const selectIsSidebarOpen = (state: RootState) => state.ui.isSidebarOpen;

export const selectIsNavBannerVisible = createSelector(
  selectSessionUserId,
  // Don't use these reference selectors directly or it won't load correctly
  (state: RootState) => selectPlan(state),
  (state: RootState) => selectIsFreeTrialUser(state),
  (userId, { data: plan }, isFreeTrial) =>
    !userId || isFreeTrial || !plan?.licenceValid,
);
